import { Injectable } from '@angular/core';
import { storeOption, StoreValue } from '../models/store';
import { BehaviorSubject } from 'rxjs';
import { StateValue } from '../models/state';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  // store options: state and store name
  storeOptions = new BehaviorSubject<storeOption>({});
  // states Value
  states:StateValue[] = [];
  // store value
  stores:StoreValue[] = [];
  // get store current value 
  storeCurrentValue:storeOption = {};

  setStoreOptions(option:storeOption){
    this.storeOptions.next(option);
  }

  setStates(states:StateValue[]){
    this.states = [...states];
  }

  setStores(stores:StoreValue[]){
    this.stores = [...stores];
  }

  get storeCurrentInfo(){
    return this.storeCurrentValue;
  }

  set storeCurrentInfo(option:storeOption){
    this.storeCurrentValue = option;
  }
}
